export default "__VITE_ASSET__jMluWiM0__"